module.exports = __webpack_public_path__ + "img/close.3bd98cd.svg";